import { Typography } from "antd";
import { capitalize } from "lodash";

export const getColoriezedValue = (value: string) => {
  /* Orange by default — Draft, and anything not listed. Work order statuses
     take the colours the status guide gives them. */
  let color = "#FFF5E9";
  let border = "#F39C12";
  if (value === "completed" || value === "approved") {
    color = "#E5F9ED";
    border = "#30CB83";
  } else if (value === "created") {
    color = "rgb(0,220,255,0.2)";
    border = "rgba(0, 0, 255, 0.6)";
  } else if (value === "in progress") {
    color = "#FFFBE6";
    border = "#D4B106";
  } else if (["declined", "rejected", "cancelled"].includes(value)) {
    color = "#FFEBEB";
    border = "#E74C3C";
  } else if (value === "expired") {
    color = "#F2F2F2";
    border = "#8C8C8C";
  } else if (["void", "voided"].includes(value)) {
    color = "#E6E6E6";
    border = "#434343";
  } else if (value === "closed") {
    color = "#F3EAFE";
    border = "#722ED1";
  }
  if (value)
    return (
      <div
        style={{
          borderRadius: 4,
          padding: "2px 8px",
          background: color,
          border: `1px solid ${color}`,
          width: "fit-content",
        }}
      >
        <Typography
          style={{
            textTransform: "capitalize",
            textAlign: "center",
            fontSize: 14,
            color: border,
          }}
        >
          {value}
        </Typography>
      </div>
    );
};

export const getColorizedValueDocuSign = (value: string) => {
  let color = "#FFF5E9";
  let border = "#F39C12";
  if (value === "completed") {
    color = "#E5F9ED";
    border = "#30CB83";
  } else if (value === "created") {
    color = "rgb(0,220,255,0.2)";
    border = "rgb(0,20,255,0.5)";
  } else if (["void", "voided", "declined", "expired", "rejected","cancelled"].includes(value)) {
    color = "#FFEBEB";
    border = "#E74C3C";
  }
  if (value)
    return (
      <div
        style={{
          borderRadius: 4,
          padding: "2px 8px",
          background: color,
          border: `1px solid ${color}`,
          width: "fit-content",
        }}
      >
        <Typography
          style={{
            textTransform: "capitalize",
            textAlign: "center",
            fontSize: 14,
            color: border,
          }}
        >
          {value}
        </Typography>
      </div>
    );
};

export const getColorizedReviewStatus = (value: string) => {
  let border = "#FFF5E9";
  let color = "#F39C12";
  if (value === "completed") {
    border = "#E5F9ED";
    color = "#30CB83";
  } else if (value === "pending") {
    border = "rgb(0,220,255,0.2)";
    color = "rgb(0,20,255,0.5)";
  } else if (value === "rejected") {
    border = "#FFEBEB";
    color = "#E74C3C";
  } else if (value === "In-Progress") {
    border = "rgb(255, 245, 233)";
    color = "rgb(243, 156, 18)";
  } else if (value === "expired") {
    border = "#FFEBEB";
    color = "#E74C3C";
  }
  if (value === "completed") {
    value = "approved";
  }
  if (value) {
    return (
      <div
        style={{
          borderRadius: 4,
          padding: "2px 8px",
          background: border,
          border: `1px solid ${border}`,
          width: "fit-content",
        }}
      >
        <Typography
          style={{
            textTransform: "capitalize",
            textAlign: "center",
            fontSize: 14,
            color: color,
          }}
        >
          {capitalize(value)}
        </Typography>
      </div>
    );
  }
};
